import React from "react";
import CompanyCategoryLayer from "./CompanyCategoryLayer";
import MasterLayout from "../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";


const CompanyCategoryPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Components / Company Categories" />

        {/* CompanyCategoryLayer */}
        <CompanyCategoryLayer />

      </MasterLayout>
    </>
  );
};

export default CompanyCategoryPage;
